import React, { useState } from 'react';
import apiService from '../../../services/api';

const formatTextForDisplay = (text) => {
    if (!text || typeof text !== 'string') return text;
    
    const trimmedText = text.trim();
    if (!trimmedText) return text;
    
    // Split by spaces and format each word
    return trimmedText.split(/\s+/).map(word => {
        // Check if word is "MFI" (case insensitive) - keep it all caps
        if (word.toUpperCase() === 'MFI') {
            return 'MFI';
        }
        // First letter capital, rest lowercase
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
};

const RecycleOfferCard = ({ offer }) => {
    const [mobileNumber, setMobileNumber] = useState('');

    const grade = formatTextForDisplay(offer.grade || offer.quality || 'Grade');
    const processType = formatTextForDisplay(offer.process_type || offer.process || 'Process');
    const mfi = offer.mfi || offer.specification || offer.specs || 'N/A';
    const packaging = formatTextForDisplay(offer.packaging || 'Packaging');
    const location = formatTextForDisplay(offer.location || offer.location_of_material || 'Location TBD');
    const offerCode = offer.offer_code || offer.code || (offer.id ? `BSB_${offer.id}` : 'BSB_000');

    // Use demo images for UI purposes
    const demoImages = [
        'assets/images/recycle/demo_img.webp',
        'assets/images/polymers/recycle1.webp'
    ];
    const imageIndex = (offer.id || 0) % demoImages.length;
    const itemImage = offer.image_url || offer.thumbnail || demoImages[imageIndex];

    const handleRequestSample = () => {
        if (typeof window !== 'undefined' && window.requestSample) {
            window.requestSample(offer.id || offerCode);
        } else {
            console.log('Request sample for:', offer.id || offerCode);
        }
    };

    const handleRequestTrial = () => {
        if (typeof window !== 'undefined' && window.requestTrialLoad) {
            window.requestTrialLoad(offer.id || offerCode);
        } else {
            console.log('Request trial for:', offer.id || offerCode);
        }
    };

    const handleSubmitPrice = async () => {
        // Validate mobile number
        const mobileClean = mobileNumber.replace(/\D/g, '');
        if (mobileClean.length !== 10) {
            alert('Please enter a valid 10-digit mobile number');
            return;
        }
        
        // Submit to backend
        try {
            const result = await apiService.submitRecycleOfferRequest({
                mobile: mobileClean,
                offer_id: offer.id,
                offer_code: offerCode,
                grade: grade,
                process_type: processType,
                mfi: mfi,
                packaging: packaging,
                location: location
            });
            
            if (result.success) {
                alert(result.message || 'Thank you for your interest! Our team will contact you shortly.');
                setMobileNumber('');
            } else {
                alert(result.message || 'Error submitting request. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting recycle offer request:', error);
            alert('Error submitting request. Please try again.');
        }
    };

    return (
        <div className="recycled-offer-card-new">
            <div className="offer-card-image">
                {itemImage && (
                    <img 
                        src={itemImage} 
                        alt="Recycled Polymer Product" 
                        className="recycle-offer-img" 
                        loading="lazy"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            if (e.target.nextElementSibling) {
                                e.target.nextElementSibling.style.display = 'flex';
                            }
                        }}
                    />
                )}
                <div className={`offer-card-image-placeholder${itemImage ? '' : ' visible'}`}>
                    <i className="fas fa-image"></i>
                </div>
            </div>
            <div className="offer-card-content">
                <div className="offer-simple-details">
                    <div className="detail-row">
                        <span className="detail-label">Grade</span>
                        <span className="detail-value">{grade}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Process</span>
                        <span className="detail-value">{processType}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">MFI</span>
                        <span className="detail-value">{formatTextForDisplay(mfi)}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Packaging</span>
                        <span className="detail-value">{packaging}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Location</span>
                        <span className="detail-value">{location}</span>
                    </div>
                </div>
                <div className="offer-card-actions-simple">
                    <div className="mobile-number-field">
                        <input 
                            type="tel" 
                            className="offer-mobile-input" 
                            id={`mobile-${offer.id || offerCode}`}
                            placeholder="10-digit mobile number" 
                            maxLength={10}
                            pattern="[0-9]{10}"
                            inputMode="numeric"
                            autoComplete="tel"
                            value={mobileNumber}
                            onChange={(e) => {
                                const v = e.target.value.replace(/\D/g, '').slice(0, 10);
                                setMobileNumber(v);
                            }}
                        />
                    </div>
                    <button 
                        className="btn-submit-price" 
                        onClick={handleSubmitPrice}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RecycleOfferCard;
